export default (function anonymous(
) {
debugger
})
